// Who may write what — the same lists the server enforces
// (backend routes/expenses.js, routes/scan.js, routes/jsaRoutes.js).
export const EXPENSE_WRITE_ROLES = ["admin", "supervisor", "field_hand"];
export const JSA_WRITE_ROLES = ["admin", "supervisor", "field_hand", "safety_officer"];
export const MANAGER_ROLES = ["admin", "supervisor"];

export const canWriteExpenses = (user) => EXPENSE_WRITE_ROLES.includes(user?.role);
export const canWriteJsa = (user) => JSA_WRITE_ROLES.includes(user?.role);

/** Edit / delete / reverse one expense: a manager, or the person who entered it. */
export function canChangeExpense(user, expense) {
  if (!canWriteExpenses(user)) return false;
  return MANAGER_ROLES.includes(user.role) || String(expense?.supervisorId || "") === String(user._id || user.id || "");
}
